import { render } from "./FormTitlePreview.vue?vue&type=template&id=604aa63b&scoped=true"
import script from "./FormTitlePreview.vue?vue&type=script&lang=js"
export * from "./FormTitlePreview.vue?vue&type=script&lang=js"

import "./FormTitlePreview.vue?vue&type=style&index=0&id=604aa63b&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604aa63b"]])

export default __exports__